module.exports = __webpack_public_path__ + "static/img/room-0.2fb33c26.png";